export default "__VITE_ASSET__COMtJCPM__"